/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';
import {
  Area,
  Detection,
  LocationDetailsOptions,
  Monitor,
  MonitorsFilters,
  UpdatedMonitor,
} from './area.model';
import { HttpClient } from '@angular/common/http';
import { mapToHttpParams } from '@bcl/common-ui';
import { ObservationDetails } from '../area-monitor/components/area-monitor-status/area-monitor-status.component';

@Injectable({ providedIn: 'root' })
export class AreaApiService {
  constructor(private http: HttpClient) {}

  public getLocationDetailsOptions(
    areaId?: number
  ): Observable<LocationDetailsOptions> {
    const url = `${environment.apiHost}/locations/options`;

    const params = mapToHttpParams({ areaId });

    return this.http.get<LocationDetailsOptions>(url, { params });
  }

  public getArea(areaId: number, visitId: number): Observable<Area> {
    const url = `${environment.apiHost}/mobile/area`;
    const params = mapToHttpParams({ AreaId: areaId, VisitId: visitId });

    return this.http.get<Area>(url, { params });
  }

  public getMonitor(monitorId: number, visitId: number): Observable<Monitor> {
    const url = `${environment.apiHost}/mobile/area/monitor`;

    const params = mapToHttpParams({
      monitorId,
      visitId,
    });

    return this.http.get<Monitor>(url, { params });
  }

  public getDetections(areaId: number): Observable<Detection[]> {
    const url = `${environment.apiHost}/mobile/area/detections`;

    const params = mapToHttpParams({
      areaId,
    });

    return this.http.get<Detection[]>(url, { params });
  }

  public getMonitors(
    areaId: number,
    visitId: number,
    filters: MonitorsFilters
  ): Observable<Area['monitors']> {
    const url = `${environment.apiHost}/mobile/area/monitors`;

    const params = mapToHttpParams({
      areaId,
      visitId,
      active: filters.status,
      module: filters.module,
      type: filters.type,
    });

    return this.http.get<Area['monitors']>(url, { params });
  }

  public updateMonitorDetails(
    updatedDetails: UpdatedMonitor
  ): Observable<void> {
    const url = `${environment.apiHost}/locations/area/monitors`;
    const body = updatedDetails;

    return this.http.patch<void>(url, body);
  }

  public changeMonitorObservation(
    monitorId: number,
    visitId: number,
    observationDetails: ObservationDetails
  ): Observable<void> {
    const url = `${environment.apiHost}/mobile/area/monitors/observation`;
    const body = {
      monitorId,
      visitId,
      observationId: observationDetails.id,
      observationDetails: observationDetails.details,
    };

    return this.http.patch<void>(url, body);
  }

  public createDetection(
    visitId: number,
    areaId: number,
    detectionSourceId: number,
    detectionTypeId: number,
    detectionCount: number,
    memo?: string
  ): Observable<{ id: number }> {
    const url = `${environment.apiHost}/mobile/detection`;
    const body = {
      visitId,
      areaId,
      detectionSourceId,
      detectionTypeId,
      detectionCount,
      memo,
    };

    return this.http.post<{ id: number }>(url, body);
  }
}
